export default "/crvUSD-MIM.884f623bd16eced6d4f304d176708006.png";